import React, {useEffect, useState} from "react";
import {getSearchFilter, setSearchFilter} from "../modules/auth-persistor";
import Loading from "./loading";
import {searchFilterSchema} from "../utils/schemas";
import {Dropdown, DropdownItem} from "react-bootstrap";
import {AppEvents} from "../utils/constants";
import {useNotifyEventsService} from "../services/notify-events-service";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import Select from "react-select";

export default function SearchParamsFilter( {onChange=null, categoriesList=[], enabledfilters=['datetimeFrom', 'datetimeTo', 'categories'], ...props} ){

    const [loading, setLoading] = useState(false);
    const [filter, _setFilter] = useState(null);
    const [tmpDatetimeFrom, setTmpDatetimeFrom] = useState('');
    const [tmpDatetimeTo, setTmpDatetimeTo] = useState('');
    const [tmpCategories, setTmpCategories] = useState([]);


    const nes = useNotifyEventsService();

    function setFilter(newFilter, trigger=true){
        _setFilter(newFilter);
        setSearchFilter(newFilter);
        nes.trigger(AppEvents.searchFilterChanged, newFilter);
        if (trigger && 'function' === typeof onChange){
            onChange(newFilter);
        }
    }

    //init position as its needed for map init
    useEffect(() => {
        let f = getSearchFilter();
        if (!f){
            const defaultFilter = searchFilterSchema.cast();
            setFilter(defaultFilter, false);
            initTmpValues(defaultFilter);
        } else {
            setFilter(f, false);
            initTmpValues(f);
        }
        nes.on(AppEvents.searchFilterChanged, reloadInternalFilter);
    }, [])

    //we need to transform the categories data to use in picker. also preload the picker with already selected data.
    useEffect(() => {
        if (categoriesList?.length > 0){
            window.categoriesList = [...categoriesList];
            initTmpValues(null, ['categories']);
        }
    }, [categoriesList]);

    const initTmpValues = (f=null, keys=enabledfilters) => {
        if (!f){
            f = getSearchFilter();
        }
        if (!f){return false;}
        if (keys.includes('datetimeFrom')){
            setTmpDatetimeFrom(f.datetimeFrom ? f.datetimeFrom : '');
        }
        if (keys.includes('datetimeTo')){
            setTmpDatetimeTo(f.datetimeTo ? f.datetimeTo : '');
        }
        if (keys.includes('categories')){
            setTimeout(()=>{
                let catsParam = f.categories ? JSON.parse(f.categories) : null;
                let cats = catsParam ? findCategoryObjectsFromIds(catsParam, window.categoriesList) : [];
                setTmpCategories(cats);
            }, 1000);
        }
    }

    const findCategoryObjectsFromIds = (catIds=[], searchList=[]) => {
        let found = [];
        if (!searchList?.length || !catIds?.length){
            return found;
        }
        searchList?.map((g)=>{
            if (g.categories?.length>0){
                g.categories.map((c)=>{
                    if (catIds.includes(c.id*1)){
                        found.push(c);
                    }
                    return c;
                })
            }
            return g;
        });
        return found;
    }

    const cancelFilters = () => {
        initTmpValues(null);
    }
    const saveFilters = () => {
        filter.datetimeFrom = tmpDatetimeFrom;
        filter.datetimeTo = tmpDatetimeTo;
        filter.categories = tmpCategories?.length ? JSON.stringify(tmpCategories.map((c)=>c.id*1)) : null;
        setFilter(filter);
    }

    const pickDatetimeFrom = (p) => {
        setTmpDatetimeFrom(p);
    }
    const pickDatetimeTo = (p) => {
        setTmpDatetimeTo(p);
    }
    const pickCategories = (p) => {
        setTmpCategories(p.length ? p : []);
    }

    const reloadInternalFilter = () => {
        const f = getSearchFilter();
        _setFilter(f);
        initTmpValues(f);
    }

    return (
        <>
            {loading===true && <Loading />}

            {!loading && <div className="d-flex gap-2 flex-wrap position-relative">

                {enabledfilters?.length>0 && filter && <Dropdown className='dropdown-md'>
                    <Dropdown.Toggle variant="light" size='sm'>
                        <span className="mdi mdi-filter-menu-outline"></span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-2" style={{minWidth:'300px'}}>
                        <div className="row">
                            {enabledfilters.includes('datetimeFrom') && <div className="form-group col-6">
                                <label className='form-label'>From date</label><br/>
                                <DatePicker
                                    name='datetimeFrom'
                                    id='datetimeFrom'
                                    className='form-control'
                                    placeholderText={'From date'}
                                    selected={!tmpDatetimeFrom ? null : new Date(tmpDatetimeFrom)}
                                    value={!tmpDatetimeFrom ? null : new Date(tmpDatetimeFrom)}
                                    onChange={val => {
                                        let newVal = val ? dayjs(val).toISOString() : null
                                        pickDatetimeFrom(newVal);
                                    }}
                                />
                            </div>
                            }

                            {enabledfilters.includes('datetimeTo') && <div className="form-group col-6">
                                <label className='form-label'>To date</label><br/>
                                <DatePicker
                                    name='datetimeTo'
                                    id='datetimeTo'
                                    className='form-control'
                                    placeholderText={'To date'}
                                    selected={!tmpDatetimeTo ? null : new Date(tmpDatetimeTo)}
                                    value={!tmpDatetimeTo ? null : new Date(tmpDatetimeTo)}
                                    onChange={val => {
                                        let newVal = val ? dayjs(val).toISOString() : null
                                        pickDatetimeTo(newVal);
                                    }}
                                />
                            </div>
                            }
                        </div>
                        {(enabledfilters.includes('datetimeFrom') ||enabledfilters.includes('datetimeTo')) && <hr />}
                        {enabledfilters.includes('categories') && categoriesList?.length>0 && <div className="form-group">
                            <label className='form-label'>Categories</label><br/>
                            <Select
                                options={categoriesList}
                                placeholder={'Choose category'}
                                closeMenuOnSelect={false}
                                blurInputOnSelect={false}
                                isSearchable
                                isClearable
                                isMulti
                                value={tmpCategories?.map(
                                    (item) => {
                                        item.value = item.id;
                                        item.label = item.name;
                                        return item;
                                    }
                                )}
                                onChange={pickCategories}
                            />
                            <hr/>
                        </div>
                        }

                        <div className="mt-2 d-flex">
                            <DropdownItem as="div" className="p-0 me-1">
                                <a className="btn btn-primary w-100 mb-1" onClick={()=>saveFilters()}>Save</a>
                            </DropdownItem>
                            <DropdownItem as="div" className="p-0">
                                <a className="btn btn-light w-100" onClick={()=>cancelFilters()}>Cancel</a>
                            </DropdownItem>
                        </div>
                    </Dropdown.Menu>
                </Dropdown>}
            </div>}

        </>
    );
}
